import React from 'react'
import Svg from './Svg'
export const SvgUnlock = React.forwardRef(({ size, ...props }, svgRef) => (
  <Svg viewBox="0 0 24 24" height={size} width={size} fill="currentColor" ref={svgRef} {...props}>
    <path d="M15.6 11.6H5.1c-.9.2-1.6.9-1.6 1.9v8.6c0 1.1.9 1.9 1.9 1.9H18c1.1 0 1.9-.9 1.9-1.9v-8.6c0-.9-.7-1.7-1.6-1.9V6.7c0-3.7-3-6.7-6.7-6.7-3.5 0-6.5 3-6.5 6.7v1.9H8V6.7c0-2.1 1.7-3.8 3.8-3.8 2.1 0 3.8 1.7 3.8 3.8v4.9z" />
  </Svg>
))
SvgUnlock.isIcon = true
export default SvgUnlock
